import { FreeSpinsInfoEvent } from '@cgs/data-access';
import {
  ComponentNames,
  IReelsConfig,
  IReelsConfigProvider,
  SLOT_GAME_SETTINGS_TOKEN,
  SpinActionComponent,
  SpinMode,
  T_IReelsConfigProvider,
} from '@cgs/machines';
import { Container, IntervalAction } from '@cgs/wge';
import { CorsicaGameSettings } from '../../corsica-game-settings';
import { CorsicaFreeSpinAction } from '../free-spins/corsica-free-spin-action';
import { CorsicaSpinAction } from './corsica-spin-action';
import { CorsicaSpinDelayFactorProvider } from './corsica-spin-delay-factor.provider';

export class CorsicaSpinActionComponent extends SpinActionComponent {
  private readonly reelsConfig: IReelsConfig;
  private readonly gameSettings: CorsicaGameSettings;
  private readonly spinDelayFactorProvider: CorsicaSpinDelayFactorProvider;

  constructor(container: Container, useSounds: boolean) {
    super(container, useSounds);

    this.reelsConfig = container.resolve<IReelsConfigProvider>(T_IReelsConfigProvider).reelsConfig;
    this.gameSettings = container.resolve<CorsicaGameSettings>(SLOT_GAME_SETTINGS_TOKEN);

    this.spinDelayFactorProvider = new CorsicaSpinDelayFactorProvider(container);
  }

  public getStartSlotAction(spinMode: SpinMode): IntervalAction {
    const isFreeSpins =
      this.gameStateMachine.curResponse.freeSpinsInfo &&
      this.gameStateMachine.curResponse.freeSpinsInfo.event != FreeSpinsInfoEvent.FreeSpinsFinished;

    if (isFreeSpins) {
      return this.freeSpinAction();
    }

    switch (spinMode) {
      default:
        return new CorsicaSpinAction(
          this.reelsEngine,
          this.gameStateMachine,
          this.gameConfig.regularSpinConfig,
          this.gameConfig.freeSpinConfig,
          this.regularSpinSoundModel,
          this.useSounds,
          this.spinDelayFactorProvider.spinDelayFactor
        );
    }
  }

  private freeSpinAction(): IntervalAction {
    const drawableComponentIndex = this.reelsEngine.entityEngine.getComponentIndex(
      ComponentNames.DrawableIndex
    );

    const stickyIconComponentIndex = this.reelsEngine.entityEngine.getComponentIndex(
      ComponentNames.StickyIcon
    );

    const lines: number[][] = [];

    for (let reel = 0; reel < this.reelsConfig.reelCount; reel++) {
      lines[reel] = [];
      for (let line = 0; line < this.reelsConfig.lineCount; line++) {
        const entity = this.reelsEngine.getStoppedEntities(reel, line)[0];

        if (!entity) {
          continue;
        }

        const drawableIndex = entity.get<number>(drawableComponentIndex);
        const hasStickyIcon = entity.hasComponent(stickyIconComponentIndex);

        if (this.gameSettings.getSpecialFreeSpinIcon().includes(drawableIndex)) {
          if (!hasStickyIcon) {
            entity.addComponent(ComponentNames.StickyIcon, true);
          }

          continue;
        }

        lines[reel].push(line);
      }
    }

    return new CorsicaFreeSpinAction(
      this.reelsEngine,
      this.gameStateMachine,
      this.gameConfig.regularSpinConfig,
      this.gameConfig.freeSpinConfig,
      this.regularSpinSoundModel,
      this.useSounds,
      lines
    );
  }
}
